module.exports = __webpack_public_path__ + "static/media/Coinsult.ebe2226d.png";